
const glossary = [
    {
        "key": "glossary.title",
        "string": "Glossary"
    },
    {
        "key": "glossary.link",
        "string": "Go to full glossary"
    }
]

export default glossary



// WEBPACK FOOTER //
// ./src/i18n/en/landingpage/glossary.js